import { Select } from 'antd';
import { SelectValue } from "antd/lib/select";
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import NumberInKimFilterStore from '../../../stores/common/number-in-kim-filter';
import './style.css';

const { Option } = Select;

const NumberInKimFilter: React.FC<{numberInKim: NumberInKimFilterStore}> = ({numberInKim}) => {

    const handleChange = (value: SelectValue) => {
        numberInKim.selectItem(value as string[]);
    }

    useEffect(() => { numberInKim.loadDictionary(); }, [numberInKim]); 

    return (
        <Select
            mode={numberInKim.multiple === true ? "multiple" : undefined}
            placeholder="номер в КИМ"
            optionLabelProp="label"
            onChange={handleChange}
            value={numberInKim.selectedItems}
            className="filter__item"
        >
            {numberInKim.items?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
        </Select>
    );
};

export default observer(NumberInKimFilter);